import React from 'react';

export const ErrorLabelTestId = 'errorlabel-input';

type ErrorLabelProps = {
  children?: string;
  className?: string;
};

const ErrorLabel: React.FC<ErrorLabelProps> = ({
  children,
  className = '',
}: ErrorLabelProps) => {
  return children ? (
    <span
      className={`${className} input-error-text text-xs ml-1`}
      data-testid={ErrorLabelTestId}
    >
      {children}
    </span>
  ) : null;
};

export default ErrorLabel;
